import { Amplify } from 'aws-amplify';
import outputs from '../amplify_outputs.json';

Amplify.configure(outputs);

// ****************************** Import CSS ******************************** //

import '/src/styles/main.scss'; 

import "./index.css";

import 'bootstrap';

// ****************************** Import Images ******************************** //

// ** LOADING SPINNER - GCS Computer ** //
import "./assets/logos/gcs-logo-pink-comp-only.png";

// ** Sponsors ** //
import "./assets/sponsor-logos/business-innovation-group.jpg";
import "./assets/sponsor-logos/city-of-savannah.png";
import "./assets/sponsor-logos/city-of-savannah-white.png";
import "./assets/sponsor-logos/fly-corps.png";
import "./assets/sponsor-logos/howmet-aerospace.png";
import "./assets/sponsor-logos/howmet-womens-network.png";
import "./assets/sponsor-logos/sams-club-blue-bkgnd.png";
import "./assets/sponsor-logos/bud-johnson-photography.png";

// **************************** Add Top Nav & Footer ************************** //

import './nav-header-footer/nav-header-footer.js';
import './nav-header-footer/nav-header-footer.css';

// ************ Add Email Signup *************** //

import './nav-header-footer/email-contact-new-classes.js';


// **************************** Add SS2026 Feature ************************** //

import './homepage-features/12-ss2026-feature/ss2026-feature.js';

// **************************** Add WC2025 Feature ************************** //


// **************************** Add FS2025 Feature ************************** //

import './homepage-features/10-fs2025-feature/fs2025-feature.js';

// **************************** Add SC2025 Feature ************************** //

import './homepage-features/9-sc2025-feature/sc2025-feature.js';

// **************************** Loading Spinner ****************************** //

window.addEventListener('DOMContentLoaded', () => {
  const preloader = document.getElementById("preloader");
  
  if (preloader) {
    preloader.style.display = "block";
    
    window.addEventListener('load', () => {
      setTimeout(() => {
        preloader.style.transition = "opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
        preloader.style.opacity = "0";
        
        setTimeout(() => {
          preloader.remove();
        }, 300);
      }, 800);
    });
  }
});

// ***************** Change InnerHTML of Hero Button for Particular Screen Width ***************** //

document.addEventListener('DOMContentLoaded', () => {
  const thumbContainer = document.querySelectorAll('.video-thumb');
  const mainVideoIframe = document.querySelector('.video-iframe iframe');

  thumbContainer.forEach(thumb => {
    thumb.addEventListener('click', function() {
      // 1. Cycle state triggers across localized thumbnails
      document.querySelectorAll('.video-thumb > img').forEach(img => img.classList.remove('active'));
      const localizedImage = this.querySelector('img');
      if (localizedImage) localizedImage.classList.add('active');

      // 2. Safe URL target swap protecting link modifications
      const sourceIframe = this.querySelector('iframe');
      if (sourceIframe && mainVideoIframe) {
        const structuralSource = sourceIframe.getAttribute('src') || '';
        // Safe explicit reassignment protection mapping
        if (structuralSource) {
          mainVideoIframe.setAttribute('src', structuralSource);
        }
      }
    });
  });
});
